export const QT2GValuesModel = {
    ip: "-1",
    port: "-1",
    user: "-1",
    pass: "-1",
    topic_data: "-1",
    topic_alerts: "-1",
    topic_control: "-1",
}
export const QT2GHasModel = {
    has_ip: false,
    has_port: false,
    has_user: false,
    has_pass: false,
    has_topic_data: false,
    has_topic_alerts: false,
    has_topic_control: false,
}